export const fesha_url = "https://nelsonlashandbrows.gettimely.com/";

export const ins_url = "https://www.instagram.com/nelsonlashandbrows";

export const fb_url = "https://www.facebook.com/Nelsonlashandbrows#";
